import useSWR from "swr";
import useTokenHook from "../context/useTokenHook";
import useUser from "../context/userHook";
import { fetchLatestColumnValuesResynchronization } from "../../utils/requests/fetchLatestColumnValues";

/**
 * Custom hook for fetching latest column values from Monday.com
 * Used for resynchronization purposes to compare current values with latest
 */
const useLatestColumnValuesResynchronization = (itemId: number, columns: any) => {
  const { token } = useTokenHook();
  const { userId, accountId } = useUser();

  // Create unique key for SWR caching
  const key = token && userId && accountId && itemId && Object.keys(columns).length > 0 ? `latestColumnValues:${itemId}:${userId}:${accountId}` : null;

  const fetcher = async () => await fetchLatestColumnValuesResynchronization(token!, columns);

  const { data, error, isLoading, isValidating, mutate } = useSWR(key, fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 5000, // Cache for 5 seconds since we want fresh data for resync
    onError: (error) => {
      console.error("Failed to fetch latest column values:", error);
    },
  });

  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useLatestColumnValuesResynchronization;
